import i18n from '@/lang/i18n'
import CheckIcon from '@/cellRenderers/common/CheckIcon'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.name'),
            field: 'name',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.middleName'),
            field: 'middleName',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.surname1'),
            field: 'surname1',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.surname2'),
            field: 'surname2',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.email'),
            field: 'contactInformation.email',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.phone'),
            field: 'contactInformation.mainPhone',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.externalCode'),
            field: 'code',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.job'),
            field: 'job.translatedName',
            filter: false,
            sortable: false,
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.laboratory'),
            field: 'defaultLaboratory.labName',
            flex: 1
        },
        {
            type: AgGridColumnType.NUMBER,
            headerName: i18n.t('configuration.grid.annualUCL'),
            field: 'expectedAnnualUCLValue',
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            field: 'active',
            minWidth: 100,
            flex: 1
        },
        {
            headerName: i18n.t('configuration.grid.user'),
            field: 'user',
            minWidth: 100,
            filter: false,
            sortable: false,
            cellRendererFramework: CheckIcon,
            flex: 1
        },
        {
            headerName: i18n.t('configuration.grid.globalValidation'),
            field: 'allowsCaseValidationByOtherUsers',
            minWidth: 160,
            filter: false,
            sortable: false,
            cellRendererFramework: CheckIcon,
            flex: 1
        }
    ]
}
